export default __webpack_public_path__ + "static/media/mariposario.d2bc8ba2.jpeg";